import * as SystemActions from 'src/app/store/system/actions/system.actions';
import * as AuthActions from 'src/app/store/auth/actions/auth.actions';
import { IResetPasswordState, initialResetPasswordState } from 'src/app/store/state/auth.resetpassword.state';
import { initialChangePasswordState, IChangePasswordState } from 'src/app/store/state/auth.changepassword.state';

export function ResetPasswordReducer (state: IResetPasswordState = initialResetPasswordState, action: AuthActions.AuthActions | SystemActions.SystemActions) {
    switch (action.type) {
        case AuthActions.RESET_PASSWORD:
        case AuthActions.REQUEST_RESET:
            return {
                ...state,
                loading: true,
                resetFail: false,
                resetSuccess: false
            };
        case AuthActions.RESET_PASSWORD_FAIL:
        case AuthActions.REQUEST_RESET_FAIL:
            return {
                ...state,
                userId: null,
                email: state.email,
                passwordToken: null,
                fromInvitation: null,
                newPassword: null,
                loading: false,
                resetFail: true,
                resetFailText: action.payload,
                resetSuccess: false
            };
        case AuthActions.REQUEST_RESET_SUCCESS:
        case AuthActions.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                userId: null,
                passwordToken: null,
                email: null,
                fromInvitation: null,
                newPassword: null,
                loading: false,
                resetFail: false,
                resetSuccess: true
            };

        case AuthActions.REQUEST_RESET_INIT:
            return{
                ...initialResetPasswordState
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialResetPasswordState;
        default:
            return state;
    }
}

export function ChangePasswordReducer (state: IChangePasswordState = initialChangePasswordState, action: AuthActions.AuthActions | SystemActions.SystemActions): IChangePasswordState {
    switch (action.type) {
        case AuthActions.CHANGE_PASSWORD:
            return {
                ...state,
                loading: true,
                changeFail: false,
                changeSuccess: false
            };
        case AuthActions.CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                newPassword: null,
                loading: false,
                changeFail: true,
                changeFailText: action.payload,
                changeSuccess: false
            };
        case AuthActions.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                fromInvitation: null,
                newPassword: null,
                loading: false,
                changeFail: false,
                changeSuccess: true,
                changeSuccessText: action.payload
            };
        case AuthActions.CHANGE_PASSWORD_RESET:
            return {
                ...state,
                loading: false,
                changeFail: false,
                changeSuccess: false
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialChangePasswordState;
        default:
            return state;
    }
}

